import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "./Api";
import Select from 'react-select';
import StaticFunctions from "./StaticFunctions";

class MainUserSelector extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        selectedCompany: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        name: 'id_main_user',
        clearable: false
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            users: null,
            value: (props.selectedCompany) ? props.selectedCompany.id_main_user : null
        };

        this.translate = this.props.baseData.translate;

        this.requestCompanyUsers = this.requestCompanyUsers.bind(this);
        this.onChange = this.onChange.bind(this);

    }

    componentWillMount() {

        this.requestCompanyUsers();

    }

    requestCompanyUsers() {

        const params = {
            action: 'getCompanyUsers',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.selectedCompany.id,
            userId: this.props.baseData.userData.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    users: res,
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    onChange(event) {

        if (!event || !event.value) return null;

        if (this.props.onChange) this.props.onChange(this.props.name, event);

        this.setState({
            value: event.value
        });

    }

    getOptions() {

        if (!this.props.selectedCompany) return [];

        const users = StaticFunctions.getSortedData(this.state.users, 'email');
        const options = [];

        users.forEach(
            (user) => {
                if (user && parseInt(user.id_company) === parseInt(this.props.selectedCompany.id)) {
                    options.push({
                        label: user['email'],
                        value: parseInt(user['id'])
                    });
                }
            }
        );

        return options;

    }

    render() {
        const options = this.getOptions();
        const selectedOption = options.find(o => parseInt(o.value) === parseInt(this.state.value)) || null;

        return (
            <Select
                name={this.props.name}
                className="chosen-container chosen-container-single"
                style={{width: '260px'}}
                options={options}
                onChange={this.onChange}
                value={selectedOption}
                placeholder={this.translate('select') + '...'}
                clearable={this.props.clearable}
                noResultsText={this.translate('noResultsFound')}
            />
        );
    }

}

export default MainUserSelector;